import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import GifCustomFrameModal from './GifCustomFrameModal';


function GifSettingsModal({ isOpen, closeModal, gifId, submitTrigger, selectedSettings, eventId, setSelectedFrame, selectedFrame, setCustomFrame, canSetCustomFrame }) {
  const [number_of_frame, setNumberOfFrame] = useState(2)
  const [interval_count_down, setIntervalCountDown] = useState(3)
  const [playback_speed, setPlayBackSpeed] = useState(1)
  const [individual_photo, setIndividualPhoto] = useState('disabled')
  const [show_overlay, showOverLayPreview] = useState(false)
  const [mirror_live, setMirrorLive] = useState(false)
  const [openModal, setOpenModal] = useState(false)

  const customStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgb(0 0 0 / 80%)',
      zIndex:100,
      width:'700x',
      height:'500x',
    },
    content: {
      position: 'relative',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'700px',
      height:'500',
      overflow: 'hidden'
    },
    closeBtn:{
      position: 'absolute',
      top:0,
      right:'-1%',
      background:'transparent',
      border:'none',
      color:'red'
    }
  
    
  };

  useEffect(()=>{

    if (selectedSettings) {
      setNumberOfFrame(selectedSettings.number_of_frame)
      setIntervalCountDown(selectedSettings.interval_count_down)
      setPlayBackSpeed(selectedSettings.playback_speed)
      setIndividualPhoto(selectedSettings.individual_photo)
      setMirrorLive(selectedSettings.mirror_live == 0 ? false : true)
      showOverLayPreview(selectedSettings.show_overlay == 0 ? false : true)
    }

  }, [selectedSettings])


  const saveChanges = () => {

    const data = {
        gifId, 
        number_of_frame, 
        interval_count_down, 
        playback_speed, 
        individual_photo, 
        show_overlay, 
        mirror_live
    }

    submitTrigger(data)

    setTimeout(()=>{
      closeModal(false)
    }, 300)
  
    setNumberOfFrame(2)
    setIntervalCountDown(3)
    setPlayBackSpeed(1)
    setIndividualPhoto('disabled')
    showOverLayPreview(false)
    setMirrorLive(false)

  }

  const openCustomFrameModal = () => {
    setOpenModal(true)
  }

  const closeCustomFrameModal = () => {
    setOpenModal(false)
  }

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      contentLabel="Gif"
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <form action="">
              <div className="mb-2 border-bottom">
                <h3>3 in 1 Animation Settings</h3>
              </div>
              <div className="mb-4 range-item">
                <p className="mb-4">Number of frames</p>
                <Slider 
                  min={2}
                  max={6}
                  defaultValue={number_of_frame} 
                  marks={{ 2: 2, 3: 3, 4: 4, 5: 5, 6: 6 }} 
                  step={6} 
                  onChange={e=> {setNumberOfFrame(e)}}
                />
              </div>
              <div className="mb-4 range-item">
                <p className="mb-2">Interval Countdown</p>
                <Slider 
                  min={1}
                  max={5}
                  defaultValue={interval_count_down} 
                  marks={{ 1: '1s', 2: '2s', 3: '3s', 4: '4s', 5: '5' }} 
                  step={6} 
                  onChange={e=> {setIntervalCountDown(e)}}
                />
              </div>
              <div className="mb-5 range-item">
                <p className="mb-2">Playback speed</p>
                <Slider 
                  min={1}
                  max={4}
                  defaultValue={playback_speed} 
                  marks={{ 1: 'Slow', 2: 'Medium', 3: 'Fast', 4: 'Super Fast' }} 
                  step={null} 
                  onChange={e=> {setPlayBackSpeed(e)}}
                />
              </div>
              {/* <div className="mb-4 d-flex justify-content-between align-items-center">
                <label style={{width: '80%'}}>Save Individual Photos:</label>
                <select className="form-control" name="save_individual_photo" onChange={e=>{setIndividualPhoto(e.target.value)}}>
                  <option value="disabled" selected={individual_photo == "disabled" ? true : ''}>Disabled</option>
                  <option value="processed" selected={individual_photo == "processed" ? true : ''}>Processed</option>
                  <option value="unprocessed" selected={individual_photo == "unprocessed" ? true : ''}>Unprocessed</option>
                </select>
              </div>
              <div className="mb-4 d-flex justify-content-between align-items-center">
                <label style={{width: '80%'}}>Show Overlay Preview:</label>
                <input type="checkbox" name="show_overlay" checked={show_overlay == 1 ? true : false } onChange={e=> {showOverLayPreview(e.target.checked)}}/>
              </div>
              <div className="mb-4 d-flex justify-content-between align-items-center">
                <label style={{width: '80%'}}>Do Not Mirror Live View: </label>
                <input type="checkbox" name="mirror_live" checked={mirror_live == 1 ? true : false } onChange={e=>{setMirrorLive(e.target.checked)}}/>
              </div> */}
              <div className="pt-4 d-flex justify-content-end border-top">
                <button type="button" className="mr-2 btn btn-primary" onClick={() => closeModal(false) } > Cancel </button>
                {canSetCustomFrame && <button type='button' className="mr-2 btn btn-primary" onClick={openCustomFrameModal}>Upload Custom Frame</button>}
                <button type="button" className="btn btn-primary" onClick={saveChanges}>Save Changes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {
        openModal &&
          <GifCustomFrameModal isOpen={openModal} closeModal={closeCustomFrameModal} eventId={eventId} setSelectedFrame={setSelectedFrame} selectedFrame={selectedFrame} setCustomFrame={setCustomFrame} />
        }
    </Modal>
  )
}

export default GifSettingsModal

